import * as React from "react";

import { ArrayFieldRenderer } from "../Interfaces/arrayFieldRenderer";

export const arrayFieldRenderer: ArrayFieldRenderer = (props) => {
  const beforeFieldContent: JSX.Element | null = props.field.beforeFieldContent ? (
    <>{props.field.beforeFieldContent}</>
  ) : null;

  const afterFieldContent: JSX.Element | null = props.field.afterFieldContent ? (
    <>{props.field.afterFieldContent}</>
  ) : null;

  const formGroupClass = props.field.ui?.formOverview?.formGroupCustomCssClass
    ? props.field.ui.formOverview.formGroupCustomCssClass
    : "";
  return (
    <div
      className={`array-field fieldset-subset ${formGroupClass} ${
        props.showCloseButton ? "fieldset-subset--withClosing" : ""
      }`}
    >
      {beforeFieldContent}
      {props.children}
      {afterFieldContent}
    </div>
  );
};
